import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestWatchVideoList = () => {
  const result = apiClient.get(
    '/user/watch_video/list',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestWatchVideo = ({ id }) => {
  let getUrl = '/user/watch_video/watch';
  if (id) {
    getUrl += `/${id}`;
  }
  const result = apiClient.get(
    getUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export {
  requestWatchVideoList,
  requestWatchVideo,
};
